const { createContext } = require("react");


const BrandsContext = createContext([]);

export default BrandsContext;